import 'css-chunksrc/client/common/elementCreationForm/styles.scss';export default {
  "elementCreationForm": "_elementCreationForm_171cc_1",
  "menu": "_menu_171cc_10",
  "input": "_input_171cc_14",
  "button": "_button_171cc_27",
  "buttonIcon": "_buttonIcon_171cc_51"
};